import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NgxPaginationModule} from 'ngx-pagination';
// import { SharedModule } from '../../pages/shared-authpipe.module';
import {TabViewModule} from 'primeng/tabview';
import {TableModule} from 'primeng/table';
import {NbCardModule ,NbPopoverModule, NbActionsModule, NbButtonModule, NbAlertModule, NbProgressBarModule, NbInputModule, NbDatepickerModule, NbSelectModule, NbCheckboxModule} from '@nebular/theme'; 
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
// import { MatFormFieldModule } from '@angular/material';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AdminPrintComponent } from './admin-print.component'
import { FileUploadModule } from 'primeng/fileupload';
import { DialogModule } from 'primeng/dialog';
import { SharedModule } from '../../shared-authpipe.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@NgModule({
schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [AdminPrintComponent],
  imports: [
    CommonModule,
    NgxPaginationModule,
    // MatFormFieldModule,
    SharedModule,
    TabViewModule,
    TableModule,
    NbCardModule,
    NbPopoverModule,
    NbSelectModule,
    ConfirmDialogModule,
    NbCheckboxModule,

    NbActionsModule,
    DialogModule,
    NbButtonModule,
    NbAlertModule,
    FileUploadModule,
    NbDatepickerModule.forRoot(),

    // MatInputModule,
    // MatSelectModule,
    // MatIconModule,
    // MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule, 
    NbProgressBarModule,
    // MatFormFieldModule, 
    // MatProgressBarModule, 
    // MatProgressSpinnerModule,
    NbInputModule
  ]
})
export class AdminPrintModule { }
